<template>
  <div class="v3-popup bag-popup score-detail-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content large">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <table>
          <thead>
            <tr>
              <th>獎品名稱</th>
              <th>獎品數量</th>
              <th>獲得時間</th>
              <th>當前狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in awardLogList" :key="index">
              <td>{{ awardConfig[item.AWARD_ID] }}</td>
              <td>{{ item.AWARD_NUM }}</td>
              <td>{{ item.CREATE_TIME }}</td>
              <td>
                <div
                  v-if="awardState(item).isVt && awardState(item).finished"
                  class="view-code-btn"
                  @click="viewCode(item)"
                >
                  {{ awardState(item).text }}
                </div>
                <span v-else>{{ awardState(item).text }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="v3-popup-content-footer">
        <div
          class="page-pre"
          :class="{ un: page <= 1 }"
          @click="handlePrevPage"
        ></div>
        <template v-for="(pageNum, index) in displayPages" :key="index">
          <div v-if="pageNum === '...'" class="page-num">...</div>
          <div
            v-else
            class="page-num"
            :class="{ active: pageNum === page }"
            @click="handlePageClick(pageNum)"
          >
            {{ pageNum }}
          </div>
        </template>
        <div
          class="page-next"
          :class="{ un: page >= totalPages }"
          @click="handleNextPage"
        ></div>
      </div>
      <div class="get-award-group">
        <div
          class="get-award-btn btns virtual"
          @click="getVirtualAwardFn"
          v-if="lotteryAndTaskState.canClaimVirtualReward"
        ></div>
        <div
          class="get-award-btn btns physical"
          @click="getPhysicalAwardFn"
          v-if="lotteryAndTaskState.canClaimMaterialReward"
        ></div>
      </div>
      <p class="bag-popup-tips">* 請在遊戲公測期間前往該頁面領取</p>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, watch, ref } from "vue";
import { awardConfig } from "@/config";
import useGetAward from "@/hooks/useGetAward";

const showCurErrorTips = inject("showCurErrorTips", () => {});
const showTipMessage = inject("showTipMessage", () => {});
const v3PopupState = inject("v3PopupState", reactive({}));
const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const {
  page,
  awardLogList,
  totalPages,
  displayPages,
  switchPage,
  initAwardList,
  resetAwardList,
  getVirtualAward,
  fillPhysicalAward,
  viewCode,
} = useGetAward(showTipMessage, showCurErrorTips);

const initActivity = inject("initActivity", async () => {});

const getVirtualAwardFn = async () => {
  const res = await getVirtualAward();
  if (res) {
    lotteryAndTaskState.canClaimVirtualReward = false;
    await initActivity();
  }
};
const getPhysicalAwardFn = async () => {
  await fillPhysicalAward();
  await initActivity();
};

// 关闭弹窗
const handleClose = () => {
  v3PopupState.bagPopupState = false;
};

const awardState = (item) => {
  const isVt = item.AWARD_VT_TYPE === "sendVt";
  const state = item.AWARD_STATE;
  return {
    isVt,
    text: state == 1 ? "未領取" : isVt ? "查看禮包碼>>" : "已領取",
    finished: state == 1 ? false : true,
  };
};

// 上一页
const handlePrevPage = () => {
  if (page.value > 1) {
    switchPage(page.value - 1);
  }
};

// 下一页
const handleNextPage = () => {
  if (page.value < totalPages.value) {
    switchPage(page.value + 1);
  }
};

// 点击页码
const handlePageClick = (pageNum) => {
  if (pageNum !== page.value && pageNum !== "...") {
    switchPage(pageNum);
  }
};

watch(
  () => v3PopupState.bagPopupState,
  (value) => {
    if (value) {
      initAwardList();
    } else {
      resetAwardList();
    }
  }
);
</script>

<style scoped lang="less">
.view-code-btn {
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
}
</style>
